angular.module('content.ContentController', [
])

/**
 * The ContentController manages scope logic and user
 * interaction.
 *
 * @class ContentController
 * @constructor
 * @module content.ContentController
 **/
.controller('ContentController', [
  '$scope',
  '$state',
  function ($scope, $state) {
    'use strict';

    $scope.state = $state;

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {}

    initialize();
  }
]);
